export default "__VITE_ASSET__B13eQyf4__"